// extracted by mini-css-extract-plugin
export default {"blob":"AboutBlob_blob__3ZQL7"};